import { environment } from '../environments/environment';

// 后端基址在【运行时】解析，不烧进构建产物。
//
// - Cloudflare Workers：Worker 从 wrangler vars 读出白名单键，SSR 渲染前写入 globalThis.__ENV__，
//   并往 HTML <head> 注入 window.__ENV__ 供浏览器端读取。改后端域名只需改 vars 重新 deploy，
//   不必重新构建 Angular 产物。
// - 本地 docker 静态镜像：无注入，回落到构建期的 environment.ts（orb.local 域名）。
//
// 必须是函数而非模块常量：SSR 下模块在 isolate 启动时就求值了，那时还拿不到 env。
type RuntimeEnv = Record<string, string | undefined>;

function runtime(): RuntimeEnv {
  return (globalThis as { __ENV__?: RuntimeEnv }).__ENV__ ?? {};
}

export function customerBaseUrl(): string {
  return runtime()['CUSTOMER_BASE_URL'] || environment.customerBaseUrl;
}
